import React from "react";
import Img from "gatsby-image";

const Phone = ({ data, selected }) => {
    const images = [
        data.iphonex_24,
        data.iphonex_immersion,
        data.iphonex_engaging,
        data.iphonex_truaccent,
        data.iphonex_tutoring,
        data.iphonex_mobile
    ];
    const phoneBackgrounds = images.map((image, index) => {
        const adjustedIndex = (index + 1).toString(); // to match numbers on data
        let screenshotClasses = "app_screenshot";
        if (selected === adjustedIndex) {
            screenshotClasses = "app_screenshot app_screenshot_active";
        }
        if (!image) return null;

        return (
            <Img
                key={image.childImageSharp.fluid.src}
                className={screenshotClasses}
                fluid={image.childImageSharp.fluid}
                style={{
                    position: "absolute",
                    left: 0,
                    top: 0,
                    width: "100%",
                    height: "100%"
                }}
            />
        );
    });

    return (
        <div className="app_phone_container">
            <div className="app_screen_container">{phoneBackgrounds}</div>
            <Img className="app_phone" fluid={data.empty_iphone.childImageSharp.fluid} alt="" />
        </div>
    );
};

export default Phone;
